export const RECAPCHA_SCRIPT = "https://www.google.com/recaptcha/api.js?render=explicit"
export const RECAPCHA_SITE_KEY = import.meta.env.VITE_CAPTCHA_SITE_KEY || "6LegouwrAAAAAJfN_mI03kNI1pZ1y30qBkD0AJIQ";
export const XTOKENSECRET = import.meta.env.VITE_X_TOKEN_SECRET || "DINEORDERKUICKPORTAL";

export const OTP_LENGTH = 6;